import {
	ChangeDetectionStrategy,
	Component,
	ViewEncapsulation,
} from '@angular/core';

import { SelectionCardBase } from '../selection-card-base';
import { SelectionCardInputComponent } from '../selection-card-input/selection-card-input';

@Component({
	selector: 'vp-selection-card-checkbox',
	imports: [SelectionCardInputComponent],
	templateUrl: '../selection-card-base.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
})
export class SelectionCardCheckboxComponent extends SelectionCardBase {
	readonly cardControlType = 'checkbox' as const;

	updateOptions(element: string): void {
		if (!element) {
			return;
		}

		const index = this.options().findIndex(
			(option) => option.inputId === element,
		);

		if (index === -1) {
			return;
		}

		// Toggle selected property of the clicked option
		this.options.update((options) => {
			return options.map((option) => {
				return option.inputId === element
					? { ...option, selected: !option.selected }
					: option;
			});
		});
		this.updateFormControl();
	}

	protected updateFormControl() {
		this.customFormControl().setValue(
			this.options()
				.filter((option) => option.selected)
				.map((option) => option.inputId),
		);
	}
}
